import { useState } from 'react';
import { inboxItems } from '@/mocks/dashboard';
import { useTheme } from '@/hooks/useTheme';

export default function InboxPanel() {
  const [read, setRead] = useState<number[]>([]);
  const { isDark } = useTheme();

  const getIconColor = (type: string) => {
    switch (type) {
      case 'alert': return '#D12229';
      case 'report': return '#0D7A3C';
      case 'digest': return '#1F5B8F';
      default: return '#B8860B';
    }
  };

  const getBg = (type: string) => {
    switch (type) {
      case 'alert': return 'rgba(209,34,41,0.08)';
      case 'report': return 'rgba(13,122,60,0.08)';
      case 'digest': return 'rgba(31,91,143,0.08)';
      default: return 'rgba(184,134,11,0.08)';
    }
  };

  const unreadCount = inboxItems.filter((i) => i.unread && !read.includes(i.id)).length;

  const cardBg = isDark ? '#1A1A1A' : '#fff';
  const cardBorder = isDark ? 'rgba(255,255,255,0.07)' : '#E5E5E8';
  const textMain = isDark ? '#E0E0E0' : '#1A1A1A';
  const textMuted = isDark ? '#6B6B70' : '#6B6B70';
  const separatorColor = isDark ? 'rgba(255,255,255,0.05)' : '#F5F5F7';
  const footerBg = isDark ? 'rgba(255,255,255,0.03)' : '#F9F9FB';
  const hoverBg = isDark ? 'rgba(255,255,255,0.04)' : '#F9F9FB';

  return (
    <div
      className="rounded-xl overflow-hidden"
      style={{ background: cardBg, border: `1px solid ${cardBorder}` }}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-3" style={{ borderBottom: `1px solid ${cardBorder}` }}>
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-semibold" style={{ color: textMain, fontFamily: 'Inter, sans-serif' }}>Inbox</h3>
          {unreadCount > 0 && (
            <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full" style={{ background: '#D12229', color: '#fff' }}>
              {unreadCount}
            </span>
          )}
        </div>
        <button className="text-xs font-medium cursor-pointer transition-colors hover:opacity-70 whitespace-nowrap" style={{ color: '#D12229', fontFamily: 'Inter, sans-serif' }}>
          Всі →
        </button>
      </div>

      {/* Items */}
      <div>
        {inboxItems.map((item, idx) => {
          const isUnread = item.unread && !read.includes(item.id);
          return (
            <div
              key={item.id}
              onClick={() => setRead((prev) => [...prev, item.id])}
              className="flex items-start gap-3 px-4 py-3 cursor-pointer transition-colors"
              style={{ borderBottom: idx < inboxItems.length - 1 ? `1px solid ${separatorColor}` : 'none' }}
              onMouseEnter={(e) => { e.currentTarget.style.background = hoverBg; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
            >
              <div
                className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 mt-0.5"
                style={{ background: getBg(item.type) }}
              >
                <i className={`${item.icon} text-sm`} style={{ color: getIconColor(item.type) }}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <span
                    className="text-xs truncate"
                    style={{
                      color: textMain,
                      fontWeight: isUnread ? 600 : 400,
                      fontFamily: 'Inter, sans-serif',
                    }}
                  >
                    {item.title}
                  </span>
                  <span className="text-[10px] shrink-0" style={{ color: textMuted, fontFamily: 'Inter, sans-serif' }}>{item.time}</span>
                </div>
                <p className="text-[11px] mt-0.5 truncate" style={{ color: item.type === 'alert' ? '#D12229' : textMuted, fontFamily: 'Inter, sans-serif' }}>
                  {item.subtitle}
                </p>
              </div>
              {isUnread && (
                <div className="w-2 h-2 rounded-full shrink-0 mt-1.5" style={{ background: '#D12229' }}></div>
              )}
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div className="px-4 py-2.5" style={{ background: footerBg, borderTop: `1px solid ${cardBorder}` }}>
        <button className="w-full text-xs font-medium text-center cursor-pointer transition-opacity hover:opacity-70 whitespace-nowrap" style={{ color: textMuted, fontFamily: 'Inter, sans-serif' }}>
          Відкрити всі повідомлення
        </button>
      </div>
    </div>
  );
}